<template>
  <section id="admin-filter">
    <h4>Consolidation Point filter</h4>
    <div class="form-group">
      <label class="form-label">Origin Port</label>
      <autocomplete
        :dataset="ports"
        title="Origin Port"
        placeHolder="Type to search"
        :initVal="entity.originPort"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectOrigin"
      ></autocomplete>
    </div>
    <div class="form-group">
      <label class="form-label">Destination Port</label>
      <autocomplete
        :dataset="ports"
        title="Destination Port"
        placeHolder="Type to search"
        :initVal="entity.destinationPort"
        v-on:changing="data => locationSearchText = data"
        :fnFormatText="displayLocation"
        :fnSelectValue="displayLocation"
        v-on:selection-made="selectDestination"
      ></autocomplete>
    </div>
    <div class="text-center">
      <div class="btn btn-primary sq"  @click="emitSearch">
        Search
      </div>
      <div class="btn btn-danger sq"  @click="close">
        Cancel
      </div>
    </div>
  </section>
</template>
<script>
  import FilterMixin from '../../mixins/FilterMixin'
  import HelperMixin from '../../mixins/Helpers'
  import Autocomplete from '../../../helpers/AutoComplete.vue'
  export default {
    name: 'ConsolidationPointFilter',
    mixins: [ FilterMixin, HelperMixin ],
    data () {
      return {
        entity: {
          originPort: '',
          destinationPort: ''
        }
      }
    },
    components: {
      Autocomplete
    },
    computed: {
      ports () {
        return this.locationSearchResults.filter(({category}) => category === 'PORT')
      }
    },
    methods: {
      selectOrigin (o) {
        this.entity.originPort = o
        this.locationSearchText = ''
        this.locationSearchResults = []
      },
      selectDestination (d) {
        this.entity.destinationPort = d
        this.locationSearchText = ''
        this.locationSearchResults = []
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/ConsolidationPoint/ConsolidationPointFilter.vue